import React from 'react';
import useEpisodePlayersContext from '@mainHooks/useEpisodePlayersContext';
import usePlayersContext from '@playerHooks/usePlayersContext';

const Twitter = () => {
    const { data } = useEpisodePlayersContext();
    const { episodeIndex } = usePlayersContext();
    const { episodeTitle } = data.episodes[episodeIndex];
    const currentUrl = window.location.href;
    const twitterShareUrl = `https://twitter.com/share?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(episodeTitle)}`;

    return (
        <a
            href={twitterShareUrl}
            className="player-app__share-link episode-player-tweeter"
            target="_blank"
            rel="noreferrer"
        >
            <svg width="22" height="20" viewBox="0 0 24 24" version="1.1" aria-hidden="true" focusable="false"><path d="M13.982 10.622 20.54 3h-1.554l-5.693 6.618L8.745 3H3.5l6.876 10.007L3.5 21h1.554l6.012-6.989L15.868 21h5.245l-7.131-10.378Zm-2.128 2.474-.697-.997-5.543-7.93H8l4.474 6.4.697.996 5.815 8.318h-2.387l-4.745-6.787Z" fill="white"></path></svg>
            <span>Post</span>
        </a>
    );
};

export default Twitter;
